"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRaceRosterDynamicStyleApi = void 0;
var _react = require("@reduxjs/toolkit/query/react");
var _objects = require("../utilities/objects");
const reducerPath = 'dynamicStyleApi';
const createRaceRosterDynamicStyleApi = baseUrl => (0, _react.createApi)({
  reducerPath,
  baseQuery: (0, _react.fetchBaseQuery)({
    baseUrl
  }),
  endpoints: builder => ({
    getRaceRosterStyles: builder.query({
      query: raceId => `/${raceId}`,
      keepUnusedDataFor: 60 * 15,
      // TODO This is temporarily shortened so that people can test.
      transformResponse: response => (0, _objects.toCamelCase)(response)
    })
  })
});
exports.createRaceRosterDynamicStyleApi = createRaceRosterDynamicStyleApi;